// extracted by mini-css-extract-plugin
export default {"timetrackmain":"tasklist_timetrackmain__JOvcN","timetrackright":"tasklist_timetrackright__ACphQ","options":"tasklist_options__VmqWL"};